<script setup>
import { onMounted, ref, watch } from "vue";
import FieldSelect from "@components/FieldSelect.vue";
import { useFilterStore } from "@stores/FilterStore";

const props = defineProps({
  autoApply: Boolean,
  labelPosition: {
    type: String,
  },
});

const filterStore = useFilterStore();
const currentSort = ref("distance");

const onChange = (value) => {
  currentSort.value = value;
  filterStore.setSortby(value);
  if (props.autoApply) {
    filterStore.applyFilter();
  }
};

// Auto-switch to lowest price after prices have had time to calculate
onMounted(() => {
  setTimeout(() => {
    currentSort.value = "price-lowest";
    filterStore.setSortby("price-lowest");
    if (props.autoApply) {
      // Skip price filter on initial automatic sort
      filterStore.skipPriceFilter = true;
      filterStore.applyFilter();
      filterStore.skipPriceFilter = false;
    }
  }, 1000); // Wait 1 second for price calculations
});
</script>

<template>
  <FieldSelect
    name="result-sort"
    label="Sort by"
    :labelPosition="labelPosition"
    v-model="currentSort"
    :required="false"
    @change="onChange"
    class="w-full">
    <template #options>
      <option value="distance">Distance</option>
      <option value="price-highest">Highest price</option>
      <option value="price-lowest">Lowest price</option>
    </template>
  </FieldSelect>
</template>

<style scoped></style>
